import { Text, useRouterPath, useStaticUrls } from 'platform-components';
import React from 'react';

import { LibraryBreadcrumbLink } from '../__link/breadcrumb__link';

export const LibraryBreadcrumbActual = () => {
    const { labLibraryActualThemes } = useStaticUrls();
    const link = useRouterPath(labLibraryActualThemes);

    return (
        <div className="theme-page__breadcrumb">
            <LibraryBreadcrumbLink to={link}>
                <Text id="library.actualThemes" size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} weight={Text.WEIGHT.M} />
            </LibraryBreadcrumbLink>
        </div>
    );
};
